import { render, staticRenderFns } from "./ExpandLessIcon.vue?vue&type=template&id=886c14ca&scoped=true&"
import script from "./ExpandLessIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandLessIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExpandLessIcon.vue?vue&type=style&index=0&id=886c14ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886c14ca",
  null
  
)

export default component.exports